import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Heart, TrendingUp, ShieldCheck, Star, CircleCheck } from "lucide-react";
const benefitsList = [{
  title: "Emotional Relief",
  description: "Take the heavy burden off your shoulders. Stop the endless stress of rising fees, aggressive sales tactics, and feeling trapped in an unfair contract.",
  icon: Heart
}, {
  title: "Financial Freedom",
  description: "End the cycle of perpetual payments. Protect your hard-earned assets and regain control over your financial future without the anchor of a timeshare mortgage.",
  icon: TrendingUp
}, {
  title: "Trusted Legal Authority",
  description: "Navigate your exit with confidence. Our team provides ethical, personalized guidance tailored to your unique situation, ensuring a secure and confidential process.",
  icon: ShieldCheck
}];
export default function RestoringYourPeaceOfMind() {
  return <section id="restoring-your-peace-of-mind" className="bg-background py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-card rounded-3xl p-8 sm:p-12 lg:p-16 shadow-xl border border-border/50">
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
            
            <div className="space-y-10">
              <div>
                <Badge variant="outline" className="mb-4 text-primary border-primary/20 bg-primary/5">
                  Your Path Forward
                </Badge>
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary font-default leading-tight mb-6">
                  Experience true Financial Freedom and Emotional Relief
                </h2>
                <p className="text-lg text-muted-foreground leading-relaxed">
                  Breaking free from a timeshare is more than just canceling a contract; it's about reclaiming your life. We provide the high-trust, professional guidance you need to step into a stress-free future.
                </p>
              </div>

              <div className="space-y-8">
                {benefitsList.map((benefit, i) => <div key={i} data-index={i} className="flex gap-4">
                    <div className="flex-shrink-0 mt-1">
                      <div className="w-12 h-12 rounded-full bg-secondary/10 flex items-center justify-center text-secondary">
                        <benefit.icon className="w-6 h-6" />
                      </div>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-primary font-default mb-2">
                        {benefit.title}
                      </h3>
                      <p className="text-muted-foreground leading-relaxed">
                        {benefit.description}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>

            <div className="relative h-[450px] sm:h-[550px] w-full mt-10 lg:mt-0">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1627436/img/lifestyle_stress_free_couple.png" alt="Couple enjoying a stress-free lifestyle" className="absolute top-0 right-0 w-[85%] h-[80%] object-cover rounded-2xl shadow-2xl border-8 border-card z-10" />
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1627436/img/lifestyle_financial_freedom_family.png" alt="Family enjoying financial stability" className="absolute bottom-0 left-0 w-[65%] h-[60%] object-cover rounded-2xl shadow-xl border-8 border-card z-20" />

              <Badge className="absolute top-8 left-0 sm:-left-6 z-30 shadow-lg bg-card text-foreground border-border py-2 px-4 text-sm font-semibold flex items-center gap-2">
                <Star className="w-4 h-4 text-yellow-500 fill-current" />
                <span>5-Star Rated Service</span>
              </Badge>

              <Badge className="absolute bottom-24 right-0 sm:-right-6 z-30 shadow-lg bg-primary text-primary-foreground py-2 px-4 text-sm font-semibold flex items-center gap-2">
                <CircleCheck className="w-4 h-4 text-secondary" />
                <span>100% Confidential</span>
              </Badge>
            </div>
          </div>

          <div className="mt-20 lg:mt-28 text-center max-w-3xl mx-auto border-t border-border/50 pt-16">
            <h3 className="text-2xl sm:text-3xl font-bold text-primary font-default mb-8">
              Ready to take the first step towards your freedom?
            </h3>
            <Button asChild className="bg-secondary hover:bg-secondary/90 text-secondary-foreground text-lg sm:text-xl px-10 sm:px-14 py-6 sm:py-8 h-auto rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 font-bold tracking-wide">
              <Link to="https://quitmytimeshare.com/eligibility-check/">
                Check Eligibility
              </Link>
            </Button>
            <p className="mt-8 text-sm text-muted-foreground">
              No guaranteed results. Every case is unique.
            </p>
          </div>

        </div>
      </div>
    </section>;
}